import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { Box } from '../../layout/Box'
import Input from '../../layout/Input'
import { SubmitButton } from '../../../styles/components/buttons'
import { Loading } from '../../data/Loading'
import { ErrorMessage } from '../../data/ErrorMessage'
import { resetPassword } from '../../../api/auth'
import { getGuidFromUrlParams } from '../../../utils/urlParams'
import { RouteType } from '../../../types/routes'
import { submitLogin } from '../login/submitLogin'
import { ApplicationState } from '../../../store'

export const ResetPassword: React.FC = () => {
  const [password, setPassword] = useState<string>('')
  const [passwordConfirmation, setPasswordConfirmation] = useState<string>('')

  const [loading, setLoading] = useState<boolean>(false)
  const [errors, setErrors] = useState<string>('')

  const salonGuid = useSelector((state: ApplicationState) => state.salon.data?.guid)

  const dispatch = useDispatch()

  const history = useHistory()

  const changePassword = async () => {
    const guid = getGuidFromUrlParams()

    if (!guid) {
      setErrors('No guid in url')
      return
    }

    if (!password || !passwordConfirmation) {
      setErrors('Passwort und Passwortbestätigung müssen ausgefüllt werden')
      return
    }

    if (password !== passwordConfirmation) {
      setErrors('Passwörter stimmen nicht überein')
      return
    }

    setLoading(true)

    const response = await resetPassword({ guid, newPassword: password })

    if (response === null) {
      setErrors('No server response')
      setLoading(false)
      return
    }

    if ('status' in response && response.status === 'Unauthorized') {
      setErrors(response.message)
      setLoading(false)
      return
    }

    if ('token' in response && 'benutzer' in response) {
      await submitLogin({
        email: response.benutzer.email,
        password,
        salonGuid: salonGuid || '',
        dispatch,
        navigate: history.push,
        redirectRoute: RouteType.Profile
      })
    }

    setLoading(false)
  }

  return (
    <Box>
      {loading && <Loading />}

      <Input label="Passwort" name="password" type="password" onChange={setPassword} />
      <Input label="Passwort bestätigen" name="passwordConfirmation" type="password" onChange={setPasswordConfirmation} />
      {errors && (
        <Box margin="0 0 1rem">
          <ErrorMessage>{errors}</ErrorMessage>
        </Box>
      )}

      <SubmitButton onClick={changePassword}>Passwort ändern</SubmitButton>
    </Box>
  )
}
